export default "__VITE_ASSET__C006Ccwt__"